import React, { useState } from 'react';
import Nav from "react-bootstrap/Nav";
import { Link } from 'react-router-dom';
import Navbar from "react-bootstrap/Navbar";

const HeaderLoggedOutMobile = () => { 
    const [expanded, setExpanded] = useState(false);

    return (
        <>
        <div className="d-block d-lg-none">
            <Navbar 
                fixed="top" 
                expanded={expanded}
                onToggle={() => setExpanded(!expanded)}
                expand="md" 
                className="navbar-custom"
                style={{
                    background: 'rgba(255, 255, 255, 0.98)',
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                    backdropFilter: 'blur(10px)'
                }}
            >
                <Navbar.Brand className="p-0" style={{marginLeft:"10px", marginRight:"10px"}}>
                    <a href="/" style={{color: "#2d3748", textDecoration:"none", fontWeight:"500"}}>
                        Elliot Koss
                    </a>
                </Navbar.Brand>
                
                <Navbar.Toggle 
                    aria-controls="mobile-nav" 
                    onClick={() => setExpanded(!expanded)}
                    style={{ 
                        border: 'none',
                        padding: '0.5rem',
                        marginRight: '10px'
                    }}
                />
                
                <Navbar.Collapse id="mobile-nav">
                    <Nav className="ms-auto" style={{ padding: '0.5rem 0' }}>
                        <Link 
                            to="/ai-notes" 
                            onClick={() => setExpanded(false)}
                            className="d-flex align-items-center"
                            style={{
                                color: "#4a5568", 
                                textDecoration: "none",
                                fontSize: "1rem", 
                                fontWeight: "400", 
                                padding: "0.75rem 1rem",
                                borderRadius: "0.25rem"
                            }}
                        >
                            AI Notes
                        </Link>
                        <Link 
                            to="/contact" 
                            onClick={() => setExpanded(false)}
                            className="d-flex align-items-center"
                            style={{
                                color: "#4a5568", 
                                textDecoration: "none",
                                fontSize: "1rem", 
                                fontWeight: "400", 
                                padding: "0.75rem 1rem",
                                borderRadius: "0.25rem"
                            }}
                        >
                            Contact
                        </Link>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </div>
        </>
    )
}

export default HeaderLoggedOutMobile;